import React from 'react';
import { Route, Switch, withRouter, useLocation } from 'react-router-dom';
import Advertisers from './Advertisers';
import Advertiser from './Advertiser';
import Admin from '../components/Admin';
import Placement from './Placement';
import Package from './Package';
import { trackPageView } from '../tracking'
import Io from './Io';
import IoCreate from './IoCreate';
import ClonePlacement from './ClonePlacement'
import CopySettings from './CopySettings'

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    trackPageView(location)
  }, [location]);
}

function Routes() {
  usePageViews();
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Advertisers} />
        <Route exact path="/advertisers" component={Advertisers} />
        <Route exact path="/advertiser/:id/ios/create" component={IoCreate} />
        <Route exact path="/advertiser/:id" component={Advertiser} />
        <Route exact path="/ios/:id/placement/create" component={Placement} />
        <Route exact path="/ios/:id/placement/create/refresh" component={Placement} />
        <Route exact path="/ios/:id/package/create" component={Package} />
        <Route exact path="/ios/:id/placement/:pid/" component={Placement} />
        <Route exact path="/ios/:id/package/:pid/" component={Package} />
        <Route exact path="/ios/:id/package/:pid/refresh" component={Package} />
        <Route exact path="/ios/:id/placement/:pid/clone" component={ClonePlacement} />
        <Route exact path="/ios/:id/placement/:pid/copysettings" component={CopySettings} />
        <Route exact path="/ios/:id/refresh" component={Io} />
        <Route exact path="/ios/:id" component={Io} />
        <Route exact path="/admin" component={Admin} />
      </Switch>
    </div>
  )
}

export default withRouter(Routes);
